module.exports = __webpack_public_path__ + "d6feedf36f760348bc448b2bc6d23738.jpg";